export enum DayOfWeekEnum {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 4,
    Thursday = 8,
    Friday = 16,
    Saturday = 32,
    Sunday = 64,
}

export function getMultiDaysOfWeekString(val: DayOfWeekEnum): string[] {
    if (val == (DayOfWeekEnum.Saturday | DayOfWeekEnum.Sunday)) {
        return ["reportSubscription.weekend"];
    }
    if (val == (DayOfWeekEnum.Monday | DayOfWeekEnum.Tuesday | DayOfWeekEnum.Wednesday | DayOfWeekEnum.Thursday | DayOfWeekEnum.Friday)) {
        return ["reportSubscription.workdays"];
    }

    let res: string[] = [];
    let availableDaysOfWeek = [
        DayOfWeekEnum.Monday,
        DayOfWeekEnum.Tuesday,
        DayOfWeekEnum.Wednesday,
        DayOfWeekEnum.Thursday,
        DayOfWeekEnum.Friday,
        DayOfWeekEnum.Saturday,
        DayOfWeekEnum.Sunday,
    ];
    availableDaysOfWeek.forEach((dw) => {
        if (val & dw) {
            res.push(getSingleDayOfWeekLabel(dw));
        }
    });

    if (!res.length) {
        res.push("common.none");
    }

    return res;
}

export function getSingleDayOfWeekLabel(dw: DayOfWeekEnum): string {
    let res = "";
    switch (dw) {
        case DayOfWeekEnum.Monday:
            res = "reportSubscription.mondayLabel";
            break;
        case DayOfWeekEnum.Tuesday:
            res = "reportSubscription.tuesdayLabel";
            break;
        case DayOfWeekEnum.Wednesday:
            res = "reportSubscription.wednesdayLabel";
            break;
        case DayOfWeekEnum.Thursday:
            res = "reportSubscription.thursdayLabel";
            break;
        case DayOfWeekEnum.Friday:
            res = "reportSubscription.fridayLabel";
            break;
        case DayOfWeekEnum.Saturday:
            res = "reportSubscription.saturdayLabel";
            break;
        case DayOfWeekEnum.Sunday:
            res = "reportSubscription.sundayLabel";
            break;
        default:
            res = "common.unknown";
            break;
    }
    return res;
}
